import React from 'react';
import styled from 'styled-components';
import Box from '../../../../../../components/box';
import { H3 } from '../../../../components';
import Container from '../../../../../../components/container';
import Cities from '../../../../../../components/courses/components/cities';

const BlockStyled = styled(Box)`
  @media (max-width: 768px) {
    padding-left: 0 !important;
  }
`;

// const LABELS_2 = [
//   'Primaire', 'Collège', 'Seconde', 'Première', 'Terminale', 'Supérieur', 'Prépa', 'BTS'
// ];

function LabelsSection({ title, citiesAround = [], ...rest }) {
  return (
    <Container {...rest}>
      <H3 fontWeight="bold">{title}</H3>

      <BlockStyled pl={6}>
        {
          <Cities
            title={`Nous avons des offres pour donner des cours particuliers et trouver un élève à :`}
            cities={citiesAround}
          />
        }

        {/* <H4 red upperCase={false}>Dans quelles disciplines es-tu compétent pour donner des cours ?</H4>

        <LabelBlock mt={4}>
          {LABELS_2.map((item, index) => (
            <Label key={index}>{item}</Label>
          ))}
        </LabelBlock> */}
      </BlockStyled>
    </Container>
  )
}

LabelsSection.defaultProps = {
  title: 'Donne des cours proche de chez toi et dans tes matières fortes',
};

export default LabelsSection;